import { RiLayout2Line, RiLineChartLine, RiMapPin2Fill, RiMoneyEuroCircleLine } from 'component-library';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { MenuItemProps } from '@/components/SignedInNavbar/Menu';
import { CONSERVATION_ORGANISATIONS } from '@/config/constants';
import { useMembershipType } from '@/hooks/useMembershipType';
import { usePathSet } from '@/hooks/usePathSet';
import { useUser } from '@/lib/auth';

export const useMenuItems = () => {
  const { t } = useTranslation();
  const membershipType = useMembershipType();
  const user = useUser();
  const isConservation = CONSERVATION_ORGANISATIONS.includes(user.membership.organization.name);
  const pathSet = usePathSet(membershipType);

  return useMemo(() => {
    const createMenuItem = (
      name: string,
      text: string,
      icon: JSX.Element,
      to: string,
      dataCy: string,
    ): MenuItemProps => ({
      active: false,
      icon,
      name,
      'data-cy': dataCy,
      text,
      to,
    });

    const menuItems: MenuItemProps[] = [
      createMenuItem(
        'projects',
        t('navbar.projects'),
        <RiLayout2Line className='h-6 w-6' />,
        pathSet.projects,
        'projects-link',
      ),
      createMenuItem(
        'investments',
        t('navbar.investments'),
        <RiMoneyEuroCircleLine className='h-6 w-6' />,
        pathSet.investments,
        'investments-link',
      ),
      createMenuItem(
        'portfolio',
        t('navbar.portfolio'),
        <RiLineChartLine className='h-6 w-6' />,
        pathSet.portfolio,
        'portfolio-link',
      ),
    ];

    if (!isConservation) {
      const plotsMenuItem = createMenuItem(
        'plots',
        t('navbar.plots'),
        <RiMapPin2Fill className='h-6 w-6' />,
        pathSet.plots,
        'plots-link',
      );
      menuItems.splice(1, 0, plotsMenuItem);
    }
    return menuItems;
  }, [t, pathSet.projects, pathSet.investments, pathSet.portfolio, pathSet.plots, isConservation]);
};
